import { Formik } from 'formik'
import { AlmanacFile } from 'types'
import { Form } from '../Form/Form'
import Styles from './SEOPlanningWizard.module.scss'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'almanac-ui/icons'
import { Tone } from 'components/DocRightRail/screens/AIAssistant/ToneSelect'
import { BlogPostLength } from '../BlogPostWizard/Types'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { FormSchema } from 'components/Wizards/Wizard/Form/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { Sections } from 'components/Wizards/Wizard/Form/Sections'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import {
  ConditionalLanguageInputField as LanguageInputField,
  ConditionalInlineLanguageInputField as InlineLanguageInputField,
} from '../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'

export type Values = {
  topic: string
  goal: string
  audience: string
  blog_length: BlogPostLength
  seo_words: Array<string>
  call_to_action: string
  author_persona: string
  product_description: string
  avoid: string
  additional_info: string
  brand_voice_id?: number
  tone: Array<Tone>
  promotion?: string
  language?: string
  project?: AlmanacFile
  filename?: string
  source_materials?: number[]
  search_term: string
  include_images?: boolean
  brand_kit_id?: number
  external_integration_id?: number
}

interface Props {
  values: Values
  onSubmit: (values: Values) => void
  schema: FormSchema<GenerationType>
}

export const StepOne = ({ onSubmit, values, schema }: Props) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={{
        topic: values.topic || '',
        goal: values.goal || '',
        audience: values.audience || '',
        blog_length: values.blog_length || BlogPostLength.Short,
        call_to_action: values.call_to_action || '',
        author_persona: values.author_persona || '',
        product_description: values.product_description || '',
        avoid: values.avoid || '',
        additional_info: values.additional_info || '',
        seo_words: values.seo_words || [],
        filename: values.filename || '',
        tone: values.tone || [],
        brand_voice_id: values.brand_voice_id,
        language: values.language,
        project: values.project,
        search_term: values.search_term,
        include_images: values.include_images || true,
        brand_kit_id: values.brand_kit_id,
      }}
    >
      {({ submitForm }) => (
        <Form.Root>
          <Sections.Root schema={schema}>
            <Sections.ManualFieldsSection
              header={
                <div className={Styles.header}>
                  <Heading level={4}>Enter a Topic for Your Blog Posts</Heading>
                  <Text variant="secondary">
                    Blaze will help you write and schedule a cluster of content around this topic linked to a Blaze
                    campaign for easy reference.
                  </Text>
                </div>
              }
            />
            <Sections.AutoFillFieldsSection>
              <ResponsiveDesign.Mobile>
                <LanguageInputField />
              </ResponsiveDesign.Mobile>
            </Sections.AutoFillFieldsSection>
            <Form.Actions isSticky>
              <Form.PrimaryActions>
                <ResponsiveDesign.Desktop>
                  <InlineLanguageInputField />
                </ResponsiveDesign.Desktop>
                <Button size="lg" onPress={() => submitForm()} endIcon={ArrowRight} fullWidth={isMobile}>
                  Choose Websites
                </Button>
              </Form.PrimaryActions>
            </Form.Actions>
          </Sections.Root>
        </Form.Root>
      )}
    </Formik>
  )
}
